Em.Handlebars.helper 'get', (context, word) ->
  return context.get(word) if context.get
  context[word]
